import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { ListView } from '@bibliocommons/deprecated-base-icons';
import { DefaultButton } from '@bibliocommons/deprecated-base-buttons';
import cn from 'classnames';

const ListViewButton = ({ currentView, toggleListView, className }) => {
  const isActive = currentView === 'small' ? 'active' : '';
  const toggleView = () => toggleListView('small');

  const btnClasses = cn(className, { active: currentView === 'small' });

  return (
    <FormattedMessage id="list_view" values={{ isActive: isActive ? 'yes' : 'no' }}>
      {message => (
        <DefaultButton
          data-test-id="list-view-button"
          flat
          className={btnClasses}
          handleClick={toggleView}
          title={message}
        >
          <ListView />
          <ScreenReaderMessage>{message}</ScreenReaderMessage>
        </DefaultButton>
      )}
    </FormattedMessage>
  );
};

ListViewButton.propTypes = {
  className: PropTypes.string,
  currentView: PropTypes.string.isRequired,
  toggleListView: PropTypes.func.isRequired
};

export default ListViewButton;
